import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const WebGuidesSection = ({ content }) => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  // Get unique categories and sort them alphabetically
  const categories = ['All', ...new Set(content.guides.map(guide => guide.category))].sort();
  
  const filteredGuides = selectedCategory === 'All' 
    ? content.guides 
    : content.guides.filter(guide => guide.category === selectedCategory);

  return (
    <div className="space-y-6">
      {/* Introduction */}
      <p className="text-gray-400">{content.intro}</p>
      
      {/* Category Filter Buttons */}
      <div className="flex flex-wrap gap-2">
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`
              px-3 py-1 rounded transition-colors duration-200
              ${selectedCategory === category 
                ? 'bg-green-500 text-black' 
                : 'bg-black border border-green-400/20 hover:border-green-400/40 hover:bg-green-500/10'
              }
            `}
            aria-pressed={selectedCategory === category}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Guides List */}
      <div className="space-y-3">
        {filteredGuides.length > 0 ? (
          filteredGuides.map((guide, index) => (
            <div 
              key={index} 
              className="flex items-baseline group hover:transform hover:translate-x-2 transition-transform duration-200"
            >
              <span className="text-green-400 mr-2 transition-transform group-hover:scale-125">•</span>
              <a 
                href={guide.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-green-400 transition-colors duration-200"
              >
                {guide.title}
                {guide.isNew && (
                  <span className="ml-2 px-2 py-0.5 bg-green-500/20 text-green-500 rounded text-xs">
                    New
                  </span>
                )}
              </a>
            </div>
          ))
        ) : (
          <p className="text-gray-400 italic">No guides found in this category</p>
        )}
      </div>
    </div>
  );
};

WebGuidesSection.propTypes = {
  content: PropTypes.shape({
    intro: PropTypes.string.isRequired,
    guides: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        category: PropTypes.string.isRequired,
        isNew: PropTypes.bool
      })
    ).isRequired
  }).isRequired
};

export default WebGuidesSection;